import { Box, SelectChangeEvent } from '@mui/material';
import { Divider, SelectField } from 'ui';
import { FunctionComponent } from 'react';
import { useHistory, useLocation } from 'react-router';
import ClowncarBodyV2 from 'components/ClowncarBodyV2';
import ClowncarHeaderV2 from 'components/ClowncarHeaderV2';
import CreateBusinessCollectionDataConfigurationForm from 'components/consumer-widget-data-configs/business-collection-data-config/CreateBusinessCollectionDataConfigurationForm';
import CreateLuceneDataConfigForm from 'components/consumer-widget-data-configs/lucene-data-config/CreateLuceneDataConfigForm';

export type DataConfigType = 'businessCollection' | 'businessLucene' | 'experienceLucene';

const CreateCollectionDataConfigRoute: FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const location = useLocation();
  const history = useHistory();

  const searchParams = new URLSearchParams(location.search);
  const dataConfigType = (searchParams.get('dataConfigType') ||
    'businessCollection') as DataConfigType;

  const goBack = () => {
    history.push({ pathname: `/tock/collection-data-configs`, search: searchParams.toString() });
  };

  const getForm = () => {
    switch (dataConfigType) {
      case 'experienceLucene':
      case 'businessLucene':
        return (
          <CreateLuceneDataConfigForm dataConfigType={dataConfigType} onCompleteOrCancel={goBack} />
        );

      default:
        return <CreateBusinessCollectionDataConfigurationForm onComplete={goBack} />;
    }
  };

  return (
    <div className="Content">
      <ClowncarHeaderV2 heading="Create new collection data configuration" />
      <div className="Main">
        <ClowncarBodyV2>
          <Box marginTop={2}>
            <DataConfigTypeSelector type={dataConfigType} />
            <Box marginTop={2} marginBottom={2}>
              <Divider></Divider>
            </Box>
            {getForm()}
          </Box>
        </ClowncarBodyV2>
      </div>
    </div>
  );
};

interface DataConfigTypeSelectorProps {
  type: DataConfigType;
}

export const DataConfigTypeSelector: React.FunctionComponent<
  React.PropsWithChildren<DataConfigTypeSelectorProps>
> = ({ type }) => {
  const history = useHistory();
  const handleChangeWidgetType = (
    event: SelectChangeEvent<{
      name?: string | undefined;
      value: unknown;
    }>
  ) => {
    history.push({ search: `?dataConfigType=${event.target.value}` });
  };

  return (
    <SelectField label="Data Config type" value={type} onChange={handleChangeWidgetType}>
      <option value="businessCollection" label="Business Collection"></option>
      <option value="businessLucene" label="Business Lucene Query"></option>
      <option value="experienceLucene" label="Experience Lucene Query"></option>
    </SelectField>
  );
};

export default CreateCollectionDataConfigRoute;
